var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-5"},[_c('loader')],1),_vm._v(" "),(_vm.error_msg != '')?_c('warning-box',{attrs:{"title":_vm.$t('warning-message.session_exp.title'),"body":_vm.error_msg,"btn_primary":_vm.$t('general.back-to-home')},on:{"yes":_vm.backToHome}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ffed182","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/restaurant/SessionValidate.vue
// module id = null
// module chunks = 